/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).fadeToggle();
      } );

      $( 'button.easy-toggle-fade-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( this ).trigger( 'focus' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#nav-overlay' ) {
            $( target ).fadeToggle();
          }
        } );
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( this ).trigger( 'focus' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#nav-overlay' ) {
            $( target ).slideToggle();
          }
        } );
      } );

      // Add cmd + ctr + g shortcut for showing grid over site if site options environment is set to development
      document.addEventListener( 'keydown', function( event ) {
        if ( event.ctrlKey && event.metaKey && event.key === 'g' ) {
          toggleGridOverlay();
        }
      } );

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* Primary button */
      $( '.btn-ghost, .mec-events-button, .mec-load-more-button, .single_add_to_cart_button, .wc-forward, .wc-block-components-totals-coupon__button, .wc-block-components-button, .woocommerce-button, .woocommerce-MyAccount-content a.button, .woocommerce-Button, .wc-block-components-button, .wp-element-button' )
          .on( 'mouseenter', function( e ) {
            if ( window.hasMotion ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--positionAwareTop', `${relY}px` );
              $( this )[0].style.setProperty( '--positionAwareLeft', `${relX}px` );
            }
          } )
          .on( 'mouseout', function( e ) {
            if ( window.hasMotion ) {
              const parentOffset = $( this ).offset();
              const relX = e.pageX - parentOffset.left;
              const relY = e.pageY - parentOffset.top;
              $( this )[0].style.setProperty( '--positionAwareTop', `${relY}px` );
              $( this )[0].style.setProperty( '--positionAwareLeft', `${relX}px` );
            }
          } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
            $( 'button[data-toggle-trigger-off].trigger-off__mobile-only' ).removeAttr( 'data-toggle-trigger-off' );
          } else {
            // is mobile
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }
      if ( $( '.mec-breadcrumbs' ).length > 0 ) {
        const updateBreadCrumbHeight = function() {
          const $breadCrumbHeight = $( '.mec-breadcrumbs' ).outerHeight();
          $( ':root' ).css( '--liftedMecBreadCrumbHeight', $breadCrumbHeight + 'px' );
        };
        updateBreadCrumbHeight();
        const throttledUpdateBreadCrumbHeight = new app.components.common.Throttle( updateBreadCrumbHeight, 250 );
        $( window ).on( 'resize', function() {
          throttledUpdateBreadCrumbHeight.run();
        } );
      }
      // set mec theme classes
      if ( $( '.mec-skin-grid-events-container' ).length ) {
        $( '.mec-skin-grid-events-container' ).addClass( 'theme-one' );
      }
      if ( $( '.mec-container' ).length ) {
        $( '.mec-container' ).addClass( 'theme-one' );
      }
      if ( $( '.mec-event-article .mec-event-content .mec-event-date' ).length ) {
        $( '.mec-event-date' ).addClass( 'theme-three' );
      }
      document.addEventListener( 'click', function( e ) {
        const toggle = e.target.closest( '.password-show' );
        if ( !toggle ) return;

        e.preventDefault();
        const input = toggle.previousElementSibling;
        if ( !input || input.tagName !== 'INPUT' ) return;

        const isShowing = toggle.classList.toggle( 'is-show' );
        input.type = isShowing ? 'text' : 'password';
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
